export default __webpack_public_path__ + "static/media/ott_dock-dark.4214050b.png";